module.exports = __webpack_public_path__ + "img/wblog-3.b0bfd8b0.png";